import {useEffect} from "react"

function Help() {
    useEffect(() => {
        document.title = "Help"
    }, [])

    return (
        <div>
            <h4>Help</h4>
        </div>
    )
}

export default Help
